<script setup lang="ts">
import type { Menu, TpgSelectEvent } from '@tpg/grammar-web';
import {
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue';

export interface GrammarMenuProps {
  anchor?: HTMLElement | null;
  isOpen?: boolean;
  label?: string;
}

const props = withDefaults(defineProps<GrammarMenuProps>(), {
  anchor: null,
  isOpen: false,
  label: '',
});

const emit = defineEmits(['select']);

const menuRef = ref<Menu | null>(null);
let menuResizeObserver: ResizeObserver | undefined;

function onSelect(event: TpgSelectEvent) {
  emit('select', event);
}

onMounted(async () => {
  await nextTick();

  const menuContainer = menuRef.value?.shadowRoot?.querySelector('.menu__container');
  if (!menuContainer) {
    return;
  }

  menuResizeObserver = new ResizeObserver(() => {
    if (!props.isOpen) {
      return;
    }

    window.dispatchEvent(new Event('resize'));
  });

  menuResizeObserver.observe(menuContainer);
});

onBeforeUnmount(() => menuResizeObserver?.disconnect());
</script>

<template>
  <tpg-menu
    ref="menuRef"
    v-bind="props"
    @tpg-select="onSelect"
  >
    <slot />
  </tpg-menu>
</template>
